module.exports = __webpack_public_path__ + "static/media/atm.610a3bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconos/atm.png
// module id = 95
// module chunks = 0